// Function to open the popup
function openPopup() {
    document.getElementById('popup').style.display = 'flex';
  
    // Check if overlay already exists
    var overlay = document.querySelector('.popup-overlay');
    if (!overlay) {
      // Add overlay to body
      overlay = document.createElement('div');
      overlay.classList.add('popup-overlay');
      document.body.appendChild(overlay);
      document.querySelector('[data-modal-background]').classList.remove('d-none');
      
    }
  
    document.body.classList.add('popup-open');
  }
  
  // Function to close the popup
  function closePopup() {
    document.getElementById('popup').style.display = 'none';
  
    // Remove overlay from body
    var overlay = document.querySelector('.popup-overlay');
    if (overlay) {
      document.body.removeChild(overlay);
      document.querySelector('[data-modal-background]').classList.add('d-none');
    }
  
    document.body.classList.remove('popup-open');
    
  }
  
  // Event listener for desktop button
  document.getElementById('openPopup').addEventListener('click', openPopup);
  
  // Event listener for mobile button
  document.getElementById('openPopupMobile').addEventListener('click', openPopup);
  
  // Event listener for close button
  document.getElementById('closePopup').addEventListener('click', closePopup);
  
  // Event listener for clicking outside the popup
  document.addEventListener('mouseup', function (e) {
    var container = document.getElementById('popup');
    var content = document.querySelector('.popup-content');
    if (!content.contains(e.target)) {
      closePopup();
    }
  });
  
  // Event listener for popup link
  document.getElementById('popupLink').addEventListener('click', function() {
    closePopup();
  });
  